module.exports = __webpack_public_path__ + "static/media/wave.2bf8d2f2.svg";